import {
    Alert as MuiAlert,
    AlertProps as MuiAlertProps,
    CircularProgress as MuiCircularProgress,
    CircularProgressProps as MuiCircularProgressProps,
    Snackbar as MuiSnackbar,
    Stack as MuiStack,
    StackProps as MuiStackProps,
    Slide,
    SnackbarOrigin,
    styled,
} from "@mui/material";
import { useMemo } from "react";
import { useSnackbar } from "../../../contexts/snackbar.context";
import { CheckCircleOutline } from "@mui/icons-material";

const CircularProgress = styled(MuiCircularProgress)<MuiCircularProgressProps>(() => ({
    color: "cyan",
}));

const Alert = styled(MuiAlert)<MuiAlertProps>(({ theme }) => ({
    paddingRight: "2rem",
    width: "18rem",
    backgroundColor: theme.custom.background.snackbar,
    boxShadow: theme.shadows[10],
    color: theme.custom.palette.snackbar.primary,
}));
Alert.defaultProps = {};

type SnackbarType = {
    withLoading?: boolean;
    anchorOrigin?: SnackbarOrigin;
};
type anchorOriginStyled = {
    top?: string;
    bottom?: string;
    left?: string;
    right?: string;
};
const getAnchorOriginStyled = ({ horizontal, vertical }: SnackbarOrigin) => {
    let styled: anchorOriginStyled = {
        top: vertical === "top" ? "14px" : undefined,
        bottom: vertical === "bottom" ? "14px" : undefined,
        left: horizontal === "right" || horizontal === "center" ? "auto" : "20px",
        right: horizontal === "left" || horizontal === "center" ? "auto" : "20px",
    };
    return styled;
};
type SnackContainerStyledProps = MuiStackProps & {
    anchor?: anchorOriginStyled;
};
const SnackContainerStyled = styled(MuiStack)<SnackContainerStyledProps>(({ anchor }) => ({
    ...anchor,
    position: "absolute",
    zIndex: 999,
}));

type SnackContainerWrappedProps = MuiStackProps & {};
const SnackContainerWrapped = styled(MuiStack)<SnackContainerWrappedProps>(() => ({
    position: "relative",
}));
SnackContainerWrapped.defaultProps = {
    spacing: 2,
};

export const Snackbar = ({ withLoading, anchorOrigin = { horizontal: "right", vertical: "bottom" } }: SnackbarType) => {
    const anchorOriginMemo: SnackbarOrigin | undefined = useMemo(() => anchorOrigin, [anchorOrigin]);
    const { enqueueSnackbars } = useSnackbar();
    return (
        <SnackContainerStyled anchor={getAnchorOriginStyled(anchorOriginMemo)}>
            <SnackContainerWrapped>
                {enqueueSnackbars.map((queue) => (
                    <Slide in={queue.active} key={queue.key} direction="right" mountOnEnter unmountOnExit>
                        <MuiSnackbar open={true} sx={{ position: "unset" }}>
                            <Alert
                                icon={
                                    queue.done ? (
                                        <CheckCircleOutline />
                                    ) : withLoading ? (
                                        <CircularProgress size="24px" />
                                    ) : undefined
                                }
                            >
                                {queue.message}
                            </Alert>
                        </MuiSnackbar>
                    </Slide>
                ))}
            </SnackContainerWrapped>
        </SnackContainerStyled>
    );
};

export default Snackbar;
